import {createContext } from "react";

export const IdeaContext = createContext()